<template>
  <button class="flex w-full flex-row text-left" @click="isOpen = !isOpen">
    <span class="flex-1 text-base font-bold capitalize-first">
      {{ $t(`enums.listeItem.${groupName}`) }}
    </span>
    <FontAwesomeIcon
      class="shrink-0"
      :icon="['fal', isOpen ? 'chevron-up' : 'chevron-down']"
    />
  </button>

  <div v-if="isOpen" class="flex flex-col gap-2">
    <div
      v-if="visibleItems.length"
      class="overflow-hidden rounded-md border border-slate-200 dark:border-slate-600"
    >
      <div
        v-for="(item, index) in visibleItems"
        :key="item.id"
        :class="index % 2 === 0 ? 'bg-gray-50 dark:bg-slate-800' : ''"
      >
        <ItemRowComponent
          :item="item"
          :group-name="groupName"
          :edition-mode="editionMode"
        />
      </div>
    </div>
    <div v-else class="py-6 text-center text-gray-400">
      {{ $t('global.no_result_found') }}
    </div>

    <template v-if="editionMode">
      <AddListItemFormComponent
        v-if="isAdding"
        :group-name="groupName"
        @close="isAdding = false"
      />
      <div v-else class="flex justify-end">
        <BaseButton
          icon="plus"
          size="small"
          :title="$t('button.add_new_m', { var: $t('global.list_item') })"
          @click="isAdding = true"
        />
      </div>
    </template>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import AddListItemFormComponent from '../../form/AddListItemFormComponent.vue'
import ItemRowComponent from './ItemRowComponent.vue'

/** A list item group, as FM's ListItemGroupComponent: collapsible. */
export default {
  name: 'ListItemComponent',
  components: { AddListItemFormComponent, FontAwesomeIcon, ItemRowComponent },
  props: {
    listItems: { type: Array, required: true },
    groupName: { type: String, required: true },
    editionMode: { type: Boolean, required: true }
  },
  data() {
    return { isOpen: false, isAdding: false }
  },
  computed: {
    visibleItems() {
      return this.listItems.filter((item) => item.visible !== false)
    }
  }
}
</script>
